import { render, staticRenderFns } from "./standardPage.vue?vue&type=template&id=b31f7be4&"
import script from "./standardPage.vue?vue&type=script&lang=js&"
export * from "./standardPage.vue?vue&type=script&lang=js&"
import style0 from "./standardPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports